import {
  Box,
  Card,
  CardHeader,
  Container,
  makeStyles,
  useMediaQuery,
  useTheme,
  LinearProgress,
  Avatar,
  CardContent,
  Divider,
  Typography,
  Link,
  Button,
  ButtonGroup,
  CircularProgress,
  List,
  ListItemText
} from "@material-ui/core";
import { AnimatePresence, AnimateSharedLayout, motion } from "framer-motion";
import React, { useCallback, useEffect, useState } from "react";
import { fade, slideRight, slideUp } from "../../util/transitions";

import Lottie from "react-lottie-player";
import animationData from "pages/PreLanding/mail.json";
import failAnimationData from "pages/PreLanding/mailfail.json";

import clsx from "clsx";
import { StringParam, useQueryParam } from "use-query-params";
import { processInvite } from "util/ProcessInvite";
import { isEmpty } from "lodash";
import { FormBuilder } from "@zennya/web-component-library/src/components/FormBuilder";
import { useHistory, useLocation } from "react-router-dom";
import { Definition, DefinitionList } from "components/Definition";
import moment from "moment-timezone";
import corporateHealthService from "services/corporate-health.service";
import {
  ICalendar,
  OutlookCalendar,
  GoogleCalendar,
  YahooCalendar,
} from "datebook";
import { Helmet } from "react-helmet";
const useStyles = makeStyles((theme) => ({
  lottie: {
    height: 250,
  },
  lottieWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  nameHeader: {
    fontWeight: "700",
    paddingBottom: theme.spacing(3),
  },
  end: {
    fontWeight: "700",
  },
  accept: {
    color: theme.palette.primary.dark,
    paddingBottom: theme.spacing(3),
  },
  decline: {
    color: theme.palette.secondary.dark,
    paddingBottom: theme.spacing(3),
  },
  inviteContent: {
    textAlign: "start",
  },
  rootContainer: {
    height: (props) => {
      return `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`;
    },
    overflowY: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  container: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  logo: {
    height: "50px",
  },
  getStarted: {
    minWidth: 300,
    marginBottom: theme.spacing(3),
  },
  clicklink: {
    paddingTop: theme.spacing(2),
  },
  actionButtons: {
    display: "flex",
    // maxWidth:300,
    alignItems: "center",
    flexDirection: "column",
    alignContent: "stretch",
    justifyContent: "center",
  },
}));

const INVITE_STATUSES = {
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  PENDING: "PENDING",
  SENT: "SENT",
};

const InviteLanding = ({ invite, code, ...props }) => {
  const classes = useStyles(props);
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();

  const [iCalendar, setICalendar] = useState(null);
  const [yahooCalendar, setYahooCalendar] = useState(null);
  const [gCalendar, setGCalendar] = useState(null);
  const [outlookCalendar, setOutlookCalendar] = useState(null);

  const [initAction, setInitAction] = useState(invite?.status);

  const [actionLoading, setActionLoading] = useState(false);
  const [actionAccept, setActionAccept] = useState(
    invite?.status === INVITE_STATUSES.ACCEPTED
  );
  const [actionComplete, setActionComplete] = useState(false);

  const [actionInit, setActionInit] = useState(true);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const [startLottieAnim, setStartLottieAnim] = useState(false);

  const generateCalendars = useCallback(
    () => {
      const calendarConfig = {
        title: invite?.event?.label,
        location: `${invite?.event?.location?.label} ${invite?.event?.location?.address}`,
        start: moment(invite?.event?.start_date).tz("Asia/Manila").toDate(),
        end: moment(invite?.event?.end_date).tz("Asia/Manila").toDate(),
      };

      const iCalendarAlarmDayBefore = {
        action: "DISPLAY",
        trigger: moment(invite?.start_date).tz("Asia/Manila").subtract(1, "days").toDate(),
        summary: invite?.event?.label,
        description: `${invite?.event?.location?.label} ${invite?.event?.location?.address}`,
      };
      const iCalendarAlarmHourBefore = {
        action: "DISPLAY",
        trigger: moment(invite?.start_date).tz("Asia/Manila").subtract(1, "hour").toDate(),
        summary: invite?.event?.label,
        description: `${invite?.event?.location?.label} ${invite?.event?.location?.address}`,
      };

      const iCal = new ICalendar(calendarConfig);
      iCal.addAlarm(iCalendarAlarmDayBefore).addAlarm(iCalendarAlarmHourBefore);
      setICalendar(iCal);
      setGCalendar(new GoogleCalendar(calendarConfig).render());
      setYahooCalendar(new YahooCalendar(calendarConfig).render());
      setOutlookCalendar(new OutlookCalendar(calendarConfig).render());
    },
    [invite?.event?.end_date, invite?.event?.label, invite?.event?.location?.address, invite?.event?.location?.label, invite?.event?.start_date, invite?.start_date],
  );
  useEffect(() => {
    if (invite && actionAccept) {
      generateCalendars()
    }
  }, [actionAccept, initAction, invite]);

  const acceptInvite = useCallback(async () => {
    setICalendar(null);
    setGCalendar(null);
    setYahooCalendar(null);
    setOutlookCalendar(null);
    setActionComplete(false);
    setActionLoading(true);
    await corporateHealthService.acceptEventInvite(code);
    generateCalendars();
    setActionAccept(true);
    setActionLoading(false);
    setActionComplete(true);
    setActionInit(false);
  }, [code, invite]);

  const declineInvite = useCallback(async () => {
    setICalendar(null);
    setGCalendar(null);
    setYahooCalendar(null);
    setOutlookCalendar(null);
    setActionComplete(false);
    setActionLoading(true);
    await corporateHealthService.declineEventInvite(code);
    setActionAccept(false);
    setActionLoading(false);
    setActionComplete(true);
    setActionInit(false);
  }, [code]);

  return (
    <motion.div
      {...fade}
      onAnimationComplete={(def) => setStartLottieAnim(true)}
    >
      <Helmet>
          <title>Zennya Event Invite - {invite?.event?.label}</title>
          <meta name="description" content={`Zennya Event Invite - ${invite?.event?.label}`} />
      </Helmet>
      <Container
        fixed
        maxWidth="md"
        className={clsx(classes.cardInset, classes.rootContainer)}
      >
        <Box className={clsx(classes.headerContainer, classes.container)}>
          <Card>
            <CardHeader
              avatar={
                <img
                  className={classes.logo}
                  alt={invite?.event?.partner?.label}
                  src={invite?.event?.partner?.logoUrl}
                />
              }
            />
            <Divider variant="middle" />
            <CardContent>
              <Typography className={classes.nameHeader} variant="h4">
                {invite?.event?.partner?.label} has invited you to an event.
              </Typography>
              <div className={classes.lottieWrapper}>
                <Lottie
                  play={startLottieAnim}
                  loop={0}
                  segments={[0, 60]}
                  animationData={animationData}
                  className={classes.lottie}
                />
              </div>
            </CardContent>
            <CardContent className={classes.inviteContent}>
              <Typography variant="body2">
                Hi {invite?.employee?.firstName},
              </Typography>
              <br/>
              <Typography variant="body2">
                {invite?.event?.partner?.label} has invited you to join the{" "}
                {invite?.event?.label}. Details are as follows:
              </Typography>
            </CardContent>
            <CardContent className={classes.inviteContent}>
              <DefinitionList>
                <Definition
                  defAlign="left"
                  compact
                  def="Event Type"
                  value={
                    <List disablePadding>
                      {invite?.event?.services.map((service, id) => (
                        <ListItemText key={id} disableTypography className={classes.value} primary={service.type.label} />
                      ))}
                    </List>
                  }
                />
                <Definition
                  defAlign="left"
                  compact
                  def="Date"
                  value={
                    `${moment(invite?.slot_date??invite?.event?.start_date).tz("Asia/Manila").format("LL LT")} PHT` ?? "-"
                  }
                />
                <Definition
                  defAlign="left"
                  compact
                  def="Location (Show map)"
                  value={
                    <Link
                      color="primary"
                      target="_blank"
                      href={`https://www.google.com/maps/?q=${invite?.event?.location?.latitude},${invite?.event?.location?.longitude}`}
                    >
                      {invite?.event?.location?.label}{" "}
                      {invite?.event?.location?.address}
                    </Link>
                  }
                />
              </DefinitionList>
            </CardContent>

            <CardContent>
              <AnimatePresence>
                <AnimateSharedLayout>
                  <motion.div
                    layout
                    {...fade}
                    className={classes.actionButtons}
                  >
                    {actionInit || (!actionLoading && actionComplete) ? (
                      <></>
                    ) : (
                      <CircularProgress />
                    )}
                    {!actionLoading &&
                    (actionComplete ||
                      [
                        INVITE_STATUSES.ACCEPTED,
                        INVITE_STATUSES.DECLINED,
                      ].includes(initAction)) ? (
                      <>
                        <Typography className={classes.end} variant="h6">
                          Thank you for your response
                        </Typography>
                        <Typography
                          className={clsx(
                            classes.end,
                            actionAccept ? classes.accept : classes.decline
                          )}
                          variant="h6"
                        >
                          You {actionAccept ? "accepted" : "declined"} the
                          invitation.
                        </Typography>
                      </>
                    ) : (
                      <></>
                    )}
                    {actionInit ||
                    (!actionLoading && actionComplete && !actionAccept) ? (
                      <Button
                        disabled={actionLoading}
                        className={classes.getStarted}
                        onClick={() => {
                          acceptInvite();
                        }}
                        variant="contained"
                        color="primary"
                      >
                        I WILL ATTEND{" "}
                        {actionLoading && (
                          <CircularProgress size={20} color="primary" />
                        )}
                      </Button>
                    ) : (
                      <></>
                    )}
                    {actionInit ||
                    (!actionLoading && actionComplete && actionAccept) ? (
                      <Button
                        disabled={actionLoading}
                        className={classes.getStarted}
                        onClick={() => {
                          declineInvite();
                        }}
                        variant="text"
                        color="primary"
                      >
                        SORRY, I CAN’T ATTEND{" "}
                        {actionLoading && (
                          <CircularProgress size={20} color="primary" />
                        )}
                      </Button>
                    ) : (
                      <></>
                    )}
                  </motion.div>

                  <motion.div layout {...fade}>
                    {iCalendar &&
                      yahooCalendar &&
                      gCalendar &&
                      outlookCalendar && (
                        <div className={classes.nameHeader}>
                          <Typography
                            className={classes.nameHeader}
                            variant="body2"
                          >
                            Save this event to your calendars
                          </Typography>
                          <ButtonGroup>
                            <Button
                              variant="outlined"
                              nClick={() => iCalendar.download()}
                              className={classes.ical}
                            >
                              iCal
                            </Button>
                            <Button
                              component={Link}
                              variant="outlined"
                              className={classes.gcal}
                              target="_blank"
                              href={gCalendar}
                            >
                              Google Calendar
                            </Button>
                            <Button
                              component={Link}
                              variant="outlined"
                              className={classes.ycal}
                              target="_blank"
                              href={yahooCalendar}
                            >
                              Yahoo Calendar
                            </Button>
                            <Button
                              component={Link}
                              variant="outlined"
                              className={classes.ocal}
                              target="_blank"
                              href={outlookCalendar}
                            >
                              Outlook Calendar
                            </Button>
                          </ButtonGroup>
                        </div>
                      )}
                  </motion.div>
                </AnimateSharedLayout>
              </AnimatePresence>
              <Typography className={classes.nameHeader} variant="h5">
                The zennya health team
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </motion.div>
  );
};

const ErrorInvite = (props) => {
  const [startLottieAnim, setStartLottieAnim] = useState(false);
  const classes = useStyles(props);
  return (
    <motion.div
      {...fade}
      onAnimationComplete={(def) => setStartLottieAnim(true)}
    >
      <Helmet>
          <title>Zennya Event Invite</title>
          <meta name="description" content="Zennya Event Invite" />
      </Helmet>
      <Container
        fixed
        maxWidth="md"
        className={clsx(classes.cardInset, classes.rootContainer)}
      >
        <Box className={clsx(classes.headerContainer, classes.container)}>
          <Card>
            <CardContent>
              <Typography className={classes.nameHeader} variant="h4">
                OOPS
              </Typography>
              <Typography variant="h5">
                The invite code is missing or incorrect or has expired
              </Typography>
              <div className={classes.lottieWrapper}>
                <Lottie
                  play={startLottieAnim}
                  loop={0}
                  segments={[0, 60]}
                  animationData={failAnimationData}
                  className={classes.lottie}
                />
              </div>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </motion.div>
  );
};

export default function InviteLandingLoader() {
  const [loading, setLoading] = useState(true);
  const [invite, setInvite] = useState();
  const [hashId, setHashId] = useQueryParam("code", StringParam);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const [expired, setExpired] = useState();

  useEffect(() => {
    async function fetchInvite() {
      if (hashId) {
        try {
          const { invite } = await processInvite(hashId);
          // const time = moment(invite?.event?.start_date).tz("Asia/Manila").format('LL LT')
          // const time2 = moment(invite?.event?.start_date).format('LL LT')
          setInvite({ ...invite});
          setExpired(
            invite?.event?.status !== "PENDING" ||
            invite?.is_expired
          );
        } catch (e) {}
      }
      setLoading(false);
    }
    fetchInvite();
  }, [hashId]);

  if (loading) {
    return <LinearProgress />;
  }
  if (hashId && invite && !expired) {
    return <InviteLanding invite={invite} code={hashId} />;
  }
  return <ErrorInvite />;
}
